import React, {useEffect, useRef, useState, useContext} from 'react';
import Cookies from 'js-cookie';
import './Modal.less';
import {ButtonPrimary, ButtonLink} from '@homeaway/react-buttons';
import {TrackingContext} from '@homeaway/react-event-tracking';
import {createCookie, cookieExists, APP_BANNER_COOKIE_NAME} from '../utils/cookies';
import * as BannerDefaults from '../banner-defaults';
import * as BannerHelpers from '../utils/bannerHelpers';
import {handleDismissEdapEvent, handleDownloadEdapEvent, handleOnloadEdapEvent} from '../utils/triggerEdapEvent';

export const BannerModal = ({buttonLabel,
    ctaLink,
    title,
    description,
    closeButtonText,
    travelerApp,
    useCanonicalPath}) => {
    buttonLabel = BannerHelpers.getButtonLabel(buttonLabel);
    const context = useContext(TrackingContext);
    const brandName = BannerHelpers.getBrandName(travelerApp);
    const site = BannerHelpers.getSite(brandName);
    const imgUrl = BannerHelpers.getImgUrl(site);
    const node = useRef();
    title = title || BannerDefaults.TITLE.replace('brand', brandName);
    description = description || BannerDefaults.DESCRIPTION;
    closeButtonText = closeButtonText || BannerDefaults.MODAL_CLOSE_BUTTON_TEXT;

    function createLink() {
        return BannerHelpers.getDownloadLink(ctaLink, brandName, Cookies.get('hav'), Cookies.get('xdid'));
    }

    const [path, setPath] = typeof window !== 'undefined' ? useState(window.location) : '';

    const [showModalState, setShowModalState] = useState(false);
    const [modalSelected, setModalSelected] = useState(null);
    const [modalPresented, setModalPresented] = useState(null);
    const [modalDismissed, setModalDismissed] = useState(null);
    const [link, setLink] = useState(createLink());

    useEffect(() => {
        if (cookieExists(APP_BANNER_COOKIE_NAME) || modalSelected || modalDismissed) {
            setShowModalState(false);
        } else {
            setShowModalState(true);
        }
    });

    useEffect(() => {
        if (useCanonicalPath && typeof window !== 'undefined') {
            setPath(window.location);
        }
    }, [path]);

    useEffect(() => {
        if (!modalPresented && !cookieExists(APP_BANNER_COOKIE_NAME) && showModalState) {
            handleOnloadEdapEvent(context, BannerDefaults.MODAL);
            setModalPresented(true);
        }
    });

    function handleDownloadButtonClick() {
        setModalSelected(true);
        handleDownloadEdapEvent(context, BannerDefaults.MODAL);
        if (useCanonicalPath) {
            setLink(`${link}&$canonical_url=${path}`);
        }
        createCookie();
    }

    function handleCloseButtonClick() {
        setModalDismissed(true);
        handleDismissEdapEvent(context, BannerDefaults.MODAL);
        createCookie();
    }

    const handleClickOutside = (e) => {
        if (node.current && !node.current.contains(e.target)) {
            setModalDismissed(true);
            handleDismissEdapEvent(context, BannerDefaults.MODAL, 'background');
        }
    };

    useEffect(() => {
        if (showModalState) {
            document.addEventListener('click', handleClickOutside);
        }
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [showModalState]);

    return (

        <div className="popup">
            {showModalState &&
                <div className="banner-modal">
                    <div className="banner-modal__container">
                        <div ref={node}>
                            <div className="banner-modal__app-icon">
                                <img src={imgUrl} alt={`${brandName} Logo`}/>
                            </div>
                            <div className="banner-modal__heading-text">
                                {title}
                            </div>
                            <div className="banner-modal__sub-heading-text">
                                {description}
                            </div>
                            <div className="banner-modal__download-button-div">
                                <ButtonPrimary onClick={handleDownloadButtonClick} href={link} data-testid="download-button-modal" className="banner-modal__get-app-icon" key={2} label={buttonLabel} />
                            </div>
                            <ButtonLink
                                size="xs"
                                className="banner-modal__close-button-text"
                                label={closeButtonText}
                                data-testid="modal-close-button"
                                onClick={handleCloseButtonClick}
                            />
                        </div>
                    </div>
                </div>
            }
        </div>
    );
};
